$(() => {

	lp.ar.Router = Backbone.Router.extend({
		// routes configuration
		routes: {
			'': 'fetchScene',
			'scene/:token': 'fetchSceneByToken'
		},
		fetchScene () {

			lp.ar.fetchScene();

		},
		fetchSceneByToken (token) {

			lp.ar.fetchScene(token);

			const url = document.location.href;
			const sceneTokenUrl = `#/scene/${token}`;

			if (url.includes(sceneTokenUrl)) {

				const hashUrl = window.location.hash?.replace(sceneTokenUrl, '');
				Backbone.history.navigate(hashUrl, { trigger: false, replace: true });

			}

		}
	});

});
